const FieldRow = ({ label, children }) => {
  // Auto-render a trailing " *" on the label string in red so required fields
  // stand out without forcing every caller to pass JSX.
  let labelNode = label;
  if (typeof label === "string" && /\s\*\s*$/.test(label)) {
    labelNode = (
      <>
        {label.replace(/\s\*\s*$/, "")} <span style={{ color: "#EF4444" }}>*</span>
      </>
    );
  }
  return (
    <div>
      <label style={{ fontSize: 11, color: "#94A3B8", fontWeight: 600, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.6 }}>{labelNode}</label>
      {children}
    </div>
  );
};

export default FieldRow;
